/** Browser tab title for logged-in users (dashboard and post–SEO-page cleanup). */
export const LOGGED_IN_APP_TITLE =
  "CliniKit – מערכת ניהול קליניקות למטפלים";

/** Meta description when restoring defaults for authenticated users (shorter than marketing SEO). */
export const LOGGED_IN_APP_DESCRIPTION =
  "מערכת ניהול קליניקות למטפלים בישראל – יומן, מטופלים, תשלומים ועוד.";
